export const TTL = {
  // The contract and its facilities move together — activating one facility
  // flips its Deal's derived status — so they expire on the same clock.
  deals: 30_000,
  facilities: 30_000,
  metrics: 60_000,
  analytics: 60_000,
  alerts: 30_000,
  files: 15_000,
  schema: 300_000,
  default: 30_000,
};

type CacheEntry = { data: unknown; cachedAt: number; ttl: number };
const store = new Map<string, CacheEntry>();
const inFlight = new Map<string, Promise<unknown>>();

export function cacheGet(key: string): unknown | null {
  const entry = store.get(key);
  if (!entry) return null;
  if (Date.now() - entry.cachedAt > entry.ttl) { store.delete(key); return null; }
  return entry.data;
}

export function cacheSet(key: string, data: unknown, ttl: number): void {
  store.set(key, { data, cachedAt: Date.now(), ttl });
}

export function cacheInvalidate(prefix: string): void {
  for (const key of store.keys()) {
    if (key.startsWith(prefix)) store.delete(key);
  }
}

export function getInFlight(key: string): Promise<unknown> | undefined {
  return inFlight.get(key);
}

export function setInFlight(key: string, promise: Promise<unknown>): void {
  inFlight.set(key, promise);
}

export function deleteInFlight(key: string): void {
  inFlight.delete(key);
}
